import { useState } from "react"
import EarnCard, { EarnOption } from "../../components/EarnCards"
import "./style/Earn.scss"

const Earn: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"staking" | "farming">("staking")
  const [showModal, setShowModal] = useState(false)

  const earnOptions: EarnOption[] = [
    { id: 1, coin: "ETH", apy: "5.2%", minLock: "0.1 ETH", duration: "30 days", type: "staking" },
    { id: 2, coin: "BTC", apy: "3.8%", minLock: "0.05 BTC", duration: "60 days", type: "staking" },
    { id: 5, coin: "BNB", apy: "4.5%", minLock: "1 BNB", duration: "90 days", type: "staking" },
    { id: 3, pair: "ETH-USDT", apr: "18.7%", tvl: "$12.5M", type: "farming" },
    { id: 4, pair: "BTC-USDT", apr: "15.2%", tvl: "$8.3M", type: "farming" },
    { id: 6, pair: "SOL-USDT", apr: "20.1%", tvl: "$5.7M", type: "farming" },
    { id: 7, pair: "ADA-USDT", apr: "14.6%", tvl: "$3.2M", type: "farming" }
  ]

  const filteredOptions = earnOptions.filter(o => o.type === activeTab)

  const handleInvestClick = () => {
    const hasBalance = false
    if (!hasBalance) setShowModal(true)
  }

  return (
    <div className="earn-page">
      <h1>Earn Crypto</h1>

      <div className="earn-tabs">
        <button
          className={activeTab === "staking" ? "active" : ""}
          onClick={() => setActiveTab("staking")}
        >
          Staking
        </button>
        <button
          className={activeTab === "farming" ? "active" : ""}
          onClick={() => setActiveTab("farming")}
        >
          Yield Farming
        </button>
      </div>

      <div className="earn-options">
        {filteredOptions.map((option, i) => (
          <EarnCard
            key={option.id}
            option={option}
            index={i}
            onInvest={handleInvestClick}
          />
        ))}
      </div>

      {showModal && (
        <div className="earn-popup">
          <div className="popup-box">
            <h3>Insufficient Balance</h3>
            <p>You do not have enough funds to invest in this asset.</p>
            <p>
              Please <a href="/contact">contact support</a> to resolve.
            </p>
            <button onClick={() => setShowModal(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  )
}

export default Earn
